"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyIsoCode = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
exports.CurrencyIsoCode = centralized_zod_1.z.enum(["SEK", "NOK"]).default("SEK");
